import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { RouteMap } from "components/common/navigation/routeMap";
import { PageNav } from "@cxagroup/casper";
import { Link, matchPath, withRouter } from "react-router-dom";
import NavLink from "components/common/navigation/NavLink";
import { getUrlWithQuery } from "cxa-utils";

export const getCurrentTopNav = (pathname, menu) =>
  menu.find(
    x =>
      (x.children &&
        x.children.filter(c => c.id === Object.keys(RouteMap).find(k => RouteMap[k] === pathname))
          .length > 0) ||
      matchPath(pathname, { path: RouteMap[x.id] })
  );

const getSecondaryRoutes = (pathname, currentTopNav) => {
  return currentTopNav.children.reduce((acc, x) => {
    if (RouteMap[x.id]) {
      acc.push({
        url: RouteMap[x.id],
        label: x.name,
        active: matchPath(pathname, { path: RouteMap[x.id] }),
        externalUrl: x.externalUrl,
      });
    }
    return acc;
  }, []);
};

const getActiveSecondaryRoute = secondaryRoutes => secondaryRoutes.find(x => x.active);

const renderNavLink = (to, className, isActive, props) => {
  const cls = `${className} ${isActive ? `${className}--active` : ""}`;

  return to.startsWith("http") ? (
    <a href={to} className={cls}>
      {props.children}
    </a>
  ) : (
    <Link to={to} {...props} className={cls} />
  );
};

const renderCurrent = (current, topRouteLabel) =>
  current ? (
    <div>
      <div className="csp-page-nav__secondary">
        <FormattedMessage id={topRouteLabel} defaultMessage={topRouteLabel} />
      </div>
      <div className="csp-page-nav__primary">
        <FormattedMessage id={current} defaultMessage={current} />
      </div>
    </div>
  ) : (
    <div className="csp-page-nav__primary">{topRouteLabel}</div>
  );

const renderSecondaryNavItem = (obj, onClick) => {
  const { label, url, externalUrl } = obj;

  return (
    <NavLink
      to={externalUrl || url}
      renderItem={renderNavLink}
      onClick={onClick}
      className="csp-page-nav__item"
    >
      <FormattedMessage id={label} defaultMessage={label} />
    </NavLink>
  );
};

renderSecondaryNavItem.propTypes = {
  label: PropTypes.string,
  url: PropTypes.string,
};

const SecondaryNav = ({ location, items, selectedLanguage }) => {
  if (!items || items.length === 0) {
    return null;
  }

  const { pathname } = location;

  const currentTopNav = getCurrentTopNav(pathname, items);
  const hasSecondaryRoutes =
    currentTopNav && currentTopNav.children && currentTopNav.children.length > 0;

  if (!hasSecondaryRoutes) {
    return null;
  }

  const { code: langCode = "" } = selectedLanguage;
  const secondaryRoutes = getSecondaryRoutes(pathname, currentTopNav).map(sRoute => {
    const { externalUrl } = sRoute;

    if (externalUrl) {
      return {
        ...sRoute,
        externalUrl: getUrlWithQuery(externalUrl, { langid: langCode.replace("-", "") }),
      };
    }

    return sRoute;
  });
  const activeSecondaryRoutes = getActiveSecondaryRoute(secondaryRoutes);

  return (
    <PageNav
      itemIdKey="url"
      items={secondaryRoutes}
      renderItem={renderSecondaryNavItem}
      current={renderCurrent(
        activeSecondaryRoutes && activeSecondaryRoutes.label,
        currentTopNav.name
      )}
    />
  );
};

SecondaryNav.propTypes = {
  location: PropTypes.object,
  items: PropTypes.array,
  selectedLanguage: PropTypes.object,
};

SecondaryNav.defaultProps = {
  selectedLanguage: {},
};

export default withRouter(SecondaryNav);



// WEBPACK FOOTER //
// ./components/common/navigation/SecondaryNav.js